/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchCode } from './BranchCode';
import {
    BranchCodeFromJSON,
    BranchCodeFromJSONTyped,
    BranchCodeToJSON,
    BranchCodeToJSONTyped,
} from './BranchCode';

/**
 * 
 * @export
 * @interface CreateSimulationCommandDto
 */
export interface CreateSimulationCommandDto {
    /**
     * 
     * @type {BranchCode}
     * @memberof CreateSimulationCommandDto
     */
    branchCode: BranchCode;
}



/**
 * Check if a given object implements the CreateSimulationCommandDto interface.
 */
export function instanceOfCreateSimulationCommandDto(value: object): value is CreateSimulationCommandDto {
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    return true;
}

export function CreateSimulationCommandDtoFromJSON(json: any): CreateSimulationCommandDto {
    return CreateSimulationCommandDtoFromJSONTyped(json, false);
}

export function CreateSimulationCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSimulationCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'branchCode': BranchCodeFromJSON(json['branchCode']),
    };
}

export function CreateSimulationCommandDtoToJSON(json: any): CreateSimulationCommandDto {
    return CreateSimulationCommandDtoToJSONTyped(json, false);
}

export function CreateSimulationCommandDtoToJSONTyped(value?: CreateSimulationCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchCode': BranchCodeToJSON(value['branchCode']),
    };
}

